import type { FormikContextType } from "formik";
import { createContext, useContext } from "react";

import type { Form } from "../ui/create-order-form-provider";

const FormikFormContext = createContext<FormikContextType<Form> | undefined>(
  void 0
);

const useCreateOrderForm = () =>
  useContext(FormikFormContext) as FormikContextType<Form>;

export { FormikFormContext, useCreateOrderForm };
